import { FormGroup, FormLabel, RadioButtonGroup, RadioButton } from '@hai/ui-react';
import { useField } from 'formik';
import React, { ChangeEvent } from 'react';
import { FormChangeEvent } from 'src/js/util/global-type';

interface RadioItem {
  label: string;
  value: string;
}

interface Props {
  className?: string;
  name?: string;
  label: string;
  labelClass?: string;
  mask?: boolean;
  radios: Array<RadioItem>;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement> & Partial<FormChangeEvent>) => void;
}

export const FormikRadios: React.FunctionComponent<Props> = ({
  name,
  label,
  labelClass = '',
  mask,
  radios,
  value,
  onChange,
  ...rest
}) => {
  const [field, meta, helper] = useField(name);
  const { value: formikValue, onChange: fieldOnChange } = field; // restField contains name, multiple and checked

  if (name !== undefined && name !== '' && value === undefined) {
    const formikValue = meta?.touched ? meta.value : meta?.initialValue; // TODO do we really need this switch, could always use .value ?
    value = value !== undefined ? value : formikValue;
  }

  return (
    <FormGroup {...rest}>
      <FormLabel className={labelClass}>{label}</FormLabel>
      <RadioButtonGroup
        className="mk-radios-horizontal"
        checkedValue={value ?? formikValue}
        groupName={name}
        onChange={(event: ChangeEvent<HTMLInputElement> & Partial<FormChangeEvent>): void => {
          // console.log('onChange', event, event.target.value);
          onChange?.(event);
          helper?.setTouched(true, false);
          helper?.setValue(event?.target?.value);
          fieldOnChange(event);
        }}
      >
        {radios?.map((radio) => {
          return (
            <RadioButton key={radio.value} value={radio.value}>
              {radio.label}
            </RadioButton>
          );
        })}
      </RadioButtonGroup>
    </FormGroup>
  );
};
